import React from 'react';


const PortfolioCard = (props) => {
	
	const { imagem, url, descricao } = props;
	
	return(
		<div className="portfolio-min-width mb-3 col-lg-6">
			<div className="zoom rounded border">
				<a href={url} target="_blank" rel="noreferrer" aria-hidden="true"><img src={imagem} className="img-fluid" alt="" /></a>
			</div>
			<div className="card mt-3 mb-2">
				<div className="p-2" style={{backgroundColor: "#F9F9F9"}}>
					{descricao}
				</div>
			</div>
		</div>
	)
}

export default PortfolioCard;
